/**
 * The Arcadia controlled audit actions for risk and quality.
 *
 * The values within this enum match the Arcadia ontology ID of type "AuditAction".
 */
export enum AuditAction {
  Approved = 'AuditApproved',
  NotRequired = 'AuditNotRequired',
  Pending = 'AuditPending',
  Rejected = 'AuditRejected',
}

export const auditActionPrefix = 'Audit';
